import { ISorter, ISorterConfig, ISorterExpression, SorterConfig } from "pbc.types";

export interface IFeldUnterkategorieSorter extends ISorter {
  id?: ISorterExpression;
  feldKategorie?: ISorterExpression;
  name?: ISorterExpression;
  initialen?: ISorterExpression;
  kommentar?: ISorterExpression;
}

export const FeldUnterkategorieSorterConfig: ISorterConfig = [
  SorterConfig('id', 'Id'),
  SorterConfig('feldKategorie', 'Feld Kategorie'),
  SorterConfig('name', 'Name'),
  SorterConfig('initialen', 'Initialen'),
  SorterConfig('kommentar', 'Kommentar')
];
